import { render, staticRenderFns } from "./KPIsTab.vue?vue&type=template&id=7f0ecdd6&scoped=true"
import script from "./KPIsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./KPIsTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./KPIsTab.vue?vue&type=style&index=0&id=7f0ecdd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0ecdd6",
  null
  
)

export default component.exports